import type { InstitutionTheme } from '../types';
import { missionCollegeColors } from './colors';

// Mission College institutional theme (W54 Worker C, S3).
//
// Brand strings from the catalog: "My Mission Portal" is the college's student portal
// (Banner Extensibility; named on every publish-API page and the important-dates page).
// Colors per ./colors.ts (the eLumen catalog theme CSS variables, `reported`).
//
// Example course codes are the three code FAMILIES the S0 probe walk found
// (onboarding/mission-college/probes/course_index_s0.json): MAT 001 (zero-padded legacy —
// the padding is part of the code), ENGL C1000 (Common Course Number, printed in the C form),
// EMSA 4401 (4-digit baccalaureate band). First entry is the primary example.
export const missionCollegeTheme: InstitutionTheme = {
  slug: 'mission-college',
  universityName: 'Mission College',
  universityShortName: 'Mission',
  registrationPortalName: 'My Mission Portal',
  exampleCourseCodes: ['MAT 001', 'ENGL C1000', 'EMSA 4401'],
  colors: missionCollegeColors,
};
